import { UserType } from '@app/enum/UserType';
import { IUserIdToNameMapping } from '@app/main/modules/foundation/foundation.interfaces';
import { IAccountUserMapping, IUser } from '@interfaces/IUser';
import { AccountUserMappingService } from '@app/services/accountUserMapping.service.ajs';
import { HybridServiceAccessor } from '../../../../common/hybrid-service-accessor';
import { FoundationUserResellerMappingService } from './userResellerMapping.service';
import { IUserResellerMapping } from '../_models/IUserResellerMapping';
import { lastValueFrom } from 'rxjs';

export class FoundationUserService {
    private readonly userResellerMappingService = new HybridServiceAccessor<FoundationUserResellerMappingService>("userResellerMappingService", this.$injector);

    static $inject = ["$q", "$http", "accountUserMappingService", "$injector"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $http: angular.IHttpService,
        private readonly accountUserMappingService: AccountUserMappingService,
        private readonly $injector: angular.auto.IInjectorService
    ) {
    }

    getUserIdToNameMappings(): angular.IPromise<IUserIdToNameMapping[]> {
        return this.getUsernameMappings().then(mappings => {
            return mappings;
        });
    }

    getEngineers(): angular.IPromise<IUser[]> {
        return this.$q.resolve([]);
    }

    getUsersForAccount(accountId: number, invalidateCache = false): angular.IPromise<IUser[]> {

        const accountMappingPromise = this.accountUserMappingService.getAccountUserMappingsForAccount(accountId, invalidateCache)

        const usersPromise = this.getUsersForAccountPromise(accountId, invalidateCache)

        const userResellerMappingsPromise = lastValueFrom(this.userResellerMappingService.service.getMappings()) as angular.IPromise<IUserResellerMapping[]>;

        return this.$q.all([accountMappingPromise, usersPromise, userResellerMappingsPromise]).then(([mappings, users, resellerMappings]) => {
                // Set current account mapping to match the account being specified

                users.forEach(user => {
                    user.AccountUserMappings = mappings.filter(mapping => mapping.UserId == user.Id);
                    user.CurrentAccountUserMapping = user.AccountUserMappings.find(m => m.AccountId == accountId);
                    user.ResellerIds = resellerMappings.filter(mapping => mapping.UserId === user.Id && !mapping.EndTime).map(mapping => mapping.ResellerId);
                });

                return users;
            });
    }

    currentUserCanUpdateAccountStatus(): angular.IPromise<boolean> {
        return this
            .$http<boolean>({
                url: `/api/foundation/users/updateaccountstatus`,
                method: "GET",
                cache: false,
                params: {}
            })
            .then(response => {
                return response.data;
            });
    }

    private getUsersForAccountPromise(accountId: number, invalidateCache = false): angular.IPromise<IUser[]> {
        return this
            .$http<IUser[]>({
                url: `/api/foundation/users/account/${accountId}`,
                method: "GET",
                cache: true,
                params: { minsToLive: 30, invalidateCache: invalidateCache }
            })
            .then(response => {
                return response.data;
            });
    }

    private getUsernameMappings(invalidateCache = false): angular.IPromise<IUserIdToNameMapping[]> {
        return this.$http<IUserIdToNameMapping[]>({
            url: `/api/foundation/users/usernamemappings`,
            method: "GET",
            cache: true,
            params: { minsToLive: 30, invalidateCache: invalidateCache }
        })
            .then(response => {
                return response.data;
            });
    }
}
